<template>
  <div class="bg-white p-b-10">
    <div style="margin-top: -20px">
      <h4 class="m-b-0 ml-1">Limit Facebook Page dan Instagram Hashtag</h4>
      <p class="hint-text ml-1">
        Halaman untuk perubahan limit Facebook Page dan Instagram Hashtag
      </p>
    </div>
    <table
      class="table table-hover table-condensed mt-5"
      id="daftar-kata"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>Nama</th>
          <th class="text-center" width="30%">Value</th>
          <th class="text-center" width="10%">Aksi</th>
        </tr>
      </thead>
      <tbody v-if="is_loading">
        <tr>
          <td colspan="3" align="center">Loading...</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="item in limit" :key="item._id.$oid">
          <td>
            {{
              item.name == "limit_facebook_page"
                ? "Limit Facebook Page"
                : "Limit Hashtag Instagram"
            }}
          </td>
          <td align="center">{{ item.value }}</td>
          <td align="center">
            <button
              id="edit-keyword"
              class="btn btn-sm btn-complete ch m-r-5"
              @click="editLimit(item)"
            >
              <i class="bi bi-pencil-square"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal.data"
      :static="true"
    />
  </div>
</template>
<script>
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_edit_limit from "@/views/components/super-admin/modal_edit_limit.vue";

export default {
  name: "tab_limit",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      is_loading: false,
      modal: null,
      modal_key: 0,
      limit: [],
    };
  },
  created() {
    this.getLimits();
  },
  methods: {
    getLimits() {
      this.is_loading = true;
      let api = process.env.VUE_APP_API_URL + "get-limits";
      this.$http
        .get(api)
        .then((res) => {
          this.limit = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    editLimit(data) {
      let name =
        data.name == "limit_facebook_page"
          ? "Limit Facebook Page"
          : "Limit Hashtag Instagram";
      if (!this.modal) {
        let arr_data = [];
        arr_data["_id"] = data._id.$oid;
        arr_data["value"] = data.value;
        arr_data["name"] = name;
        this.modal = {
          title: "Edit " + name,
          subtitle: "Silahkan masukan limit terbaru",
          component: modal_edit_limit,
          data: arr_data,
        };
      } else {
        let arr_data = [];
        arr_data["_id"] = data._id.$oid;
        arr_data["value"] = data.value;
        arr_data["name"] = name;
        this.modal = {
          title: "Edit " + name,
          subtitle: "Silahkan masukan limit terbaru",
          component: modal_edit_limit,
          data: arr_data,
        };
        this.modal_key++;
      }
    },
  },
};
</script>